import { BriefcaseIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMatterCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface MatterCreatedEventProps {
  event: DiscriminatedMatterCreatedEvent;
}

const DetailsField = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="text-xs text-gray-500">
      {label}: {value}
    </div>
  );
};

export const MatterCreatedEvent: React.FC<MatterCreatedEventProps> = ({
  event,
}) => {
  const { matter } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-purple-100">
          <BriefcaseIcon className="h-4 w-4 text-purple-600" />
        </div>
      }
    />
  );

  const { date_of_loss, statute_of_limitations_date } = matter;

  const body = (
    <ActivityBody>
      {matter.name && <ActivityTitle>{matter.name}</ActivityTitle>}
      <ActivityDescription>
        {matter.status && <DetailsField label="Status" value={matter.status} />}
        {date_of_loss && (
          <DetailsField label="Date of Loss" value={date_of_loss} />
        )}
        {statute_of_limitations_date && (
          <DetailsField
            label="Statute of Limitations Date"
            value={statute_of_limitations_date}
          />
        )}
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Matter Created"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
